module.exports = __webpack_public_path__ + "img/edge-box.84412441.png";